
var novicell = novicell || {};

novicell.breakingNews = new function(){
    var self = this;
    var $body = $('body');

    this.init = function () {
        $.ajax({
            url: "/umbraco/api/BreakingNewsApi/GetBreakingNews",
            type: "GET",
            dataType: "json",
            success: function (data) {

                $('#site').prepend(data.Content);

                var breakingInfoUpdatedate = $('#breaking-news').data("updatedate");
                if (getCookie("cookieBreaking") !== breakingInfoUpdatedate) {
                    setTimeout(function () {
                        $body.addClass('breaking-info-show');
                    }, 1000);
                }

                $('#breaking-news-close').on("click", function () {
                    // setCookie("cookieBreaking", breakingInfoUpdatedate, 365);
                    if ($('#breaking-news-close').hasClass('cookie-info__toggle-off')) {
                        $(this).removeClass('cookie-info__toggle-off').addClass('cookie-info__toggle-on');
                        $('.cookie-info__text-hidden').removeClass('cookie-info__text-hidden').addClass('cookie-info__text-visible');
                        $('.breaking-info').css("max-height", "100vh");
                        $('.breaking-info').addClass("open");

                    } else {
                        $('.breaking-info').css("max-height", "65px");
                        $('.breaking-info').removeClass("open");

                        function changeSize() {
                            $('#breaking-news-close').removeClass('cookie-info__toggle-on').addClass('cookie-info__toggle-off');
                            $('.cookie-info__text-visible').removeClass('cookie-info__text-visible').addClass('cookie-info__text-hidden');
                        }
                        const timeOut = setTimeout(changeSize, 250);

                    }
                });
            }
        });
    };
};

/* Cookie helper functions
-*******************************/

// Get cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)===' '){ c = c.substring(1) };
        if (c.indexOf(name) === 0){ return c.substring(name.length,c.length)};
    }
    return "";
}

// Set cookie
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 60 * 60 * 1000 * 24));
    var expires = "expires=" + d.toUTCString() + ";";
    var path = "path=/";
    document.cookie = cname + "=" + cvalue + "; " + expires + path;
}
